var XPortal = XPortal || {};
XPortal.TagsEditor = (function () {
    var self = {
        $typeahead: null,
        controlSelector: ".portal-tags-editor",
        controlInputSelector: ".portal-tags",
        valueSeparator: "_#_",
        items: [],
        init: function (container) {
            container = container || $(XPortal.Main.DetailFormSelector);
            const modelName = XPortal.Store.getModelName(container[0].id);
            // embed-detail not need to init tags
            if (modelName.includes("embed-detail")) {
                return;
            }

            container.find(self.controlSelector).each(function (ip, element) {
                initFor($(element), modelName, false);
            });
        },
        GetSettings: function (element, modelName) {
            if (element.data("tags-id")) return self.items[element.data("tags-id")];
            const input = element.find(self.controlInputSelector);
            let sttgs = XPortal.Main.GetSettingsFor(input);
            element.data("tags-id", sttgs.editorkey);
            if (modelName) sttgs.modelName = modelName;
            sttgs.ispopup = XPortal.Store.GetModelByName(modelName).model.isPopup || false; // on a detailpage is undefined
            sttgs.allownew = (/true/i).test(sttgs.allownew);
            sttgs.flowtoheader = (/true/i).test(sttgs.flowtoheader);
            sttgs = self.items[sttgs.editorkey] = Object.assign(sttgs, { hint: false, autocomplete: true, highlight: true, minLength: 1, async: true, limit: 1000 }, XPortal.Utils.readJsonStr(element.attr("data-opts"), {}));
            element.removeAttr("data-opts");
            const hasTags = (sttgs.tags && sttgs.tags.length) ? true : false;
            sttgs.data = {
                items: hasTags ? sttgs.tags.split(self.valueSeparator).map(x => getTagValueModel(x, element, sttgs)) : [],
                isnotags: !hasTags,
                addtagstext: hasTags ? "" : XPortal.Localization.GetCachedString("XTags.DataFormat.AddTagsBtn", "ADD TAGS"),
                removeTag: function (e) {
                    removeTag(sttgs, input, element, e);
                },
                showInput: function (e) {
                    let addTag = $(e.target).closest(".add-tag");
                    addTag.addClass("d-none");
                    $(e.target).closest(".add-tags").addClass("d-none");
                    input.removeClass("d-none");
                    input.typeahead('val', " ").trigger("focus");
                    input.typeahead('val', '');
                }
            };
            return sttgs;
        },
        BindOnGridEvents: function (gridInfo) {
            rebuildTagsGrid();
            if (gridInfo.kgrid) {
                gridInfo.kgrid.bind("columnResize", grid_columnResize);
                gridInfo.kgrid.bind("databound", rebuildTagsGrid());
            }
        },
        GetTagsTooltip: function ($target) {
            let tagsStr = $target.find(".edit-tags").data("tags");
            let tags = tagsStr.length > 0 ? tagsStr.split(self.valueSeparator) : [];
            var template = kendo.template($("#tagsTooltip").html());
            return template(tags);
        },
        InitPopUpControllTags: function (content, opts, item) {
            let controlInput = content.find(".portal-tags");
            const curTagsElement = content.find(".current-tags");
            if (controlInput && controlInput.length && curTagsElement && curTagsElement.length) {
                const tags = opts.tags || [];
                const uniqueid = opts.uniqueid || item.UniqueId;
                const nodeid = opts.nodeid || item.NodeId;
                controlInput.attr("data-tags", tags);
                controlInput.attr("data-allownew", opts.allownew);
                controlInput.attr("data-pageid", nodeid);
                controlInput.attr("data-itemuniqueid", uniqueid);
                controlInput.attr("data-metadata-fieldname", opts.fieldname);
                controlInput.attr("data-groupCode", opts.groupcode);
                controlInput.attr("data-editorkey", opts.editorkey || opts.editorid);
                const saveTagsBtn = content.find(".save-tags-btn");
                if (saveTagsBtn && saveTagsBtn.length)
                    saveTagsBtn.attr("data-itemuniqueid", uniqueid);
                const titleEl = content.find(".edit-btns-wrapper .form-title");
                if (titleEl && titleEl.length) $(titleEl).text(opts.title);
                relocateInputPopup();
                saveBtnToFooterPopup(opts.ispopup);

                if (item) {
                    const form = content.find("#popup_tags-page form");
                    const data = {
                        "EntityAlias": item.EntityAlias,
                        "Alias": item.Alias || item.EntityAlias,
                        "UniqueId": item.uniqueid || uniqueid,
                        "CreatedBy": item.CreatedBy,
                        "NodeId": item.nodeId || nodeid,
                    };
                    form.attr("data-settings", JSON.stringify(data));
                    controlInput.attr("data-entityAlias", item.EntityAlias);
                }

            }
            content.closest(".modal-content").css("height", opts.maxHeight);
            content.closest(".modal-content").find('.modal-footer').remove();
            return content
        },
        GetTagsDialogPopup: function (opts, item, el) {
            const templateSrc = opts.ispopup ? "#tagsDialogTemplate" : el.attr("data-src");
            opts.maxHeight = opts.maxHeight ? opts.maxHeight : opts.height || opts.popupheight;
            opts.strSettings = encodeURIComponent(JSON.stringify(opts));
            return new Promise((onOk, onError) => {
                opts.template = (opts.template || "").toLowerCase();
                opts.templateContainer = $("<div></div>");
                opts.templateContainer.html(XPortal.Template.TemplateToHtml(opts, $("#popup-detail-page").html()));
                opts.popupObj = XPortal.EditActions.initModalPopup($('#extended-popup-box'), opts, false, false);

                const content = opts.popupObj.find(".popup-detail-content");
                content.html($(templateSrc).html());
                $('.portal-tags.portal-tags-popup__input').attr('placeholder', XPortal.Localization.GetCachedString("XPortal.DataFormat.Tags.Placeholder", "Start typing and press Enter"));
                $('.cancel-tags-btn').text(XPortal.Localization.GetCachedString("XPortal.DataFormat.Tags.CancelButton", "CANCEL"));
                $('label.add-btn-text').text(XPortal.Localization.GetCachedString("XPortal.DataFormat.Tags.AddlButton", "ADD"));

                content.html(XPortal.TagsEditor.InitPopUpControllTags(content, opts, item).html());
                XPortal.EditForm.PopupReloaded("#popup_tags-page", function () { return XPortal.FEditor ? XPortal.FEditor.Update({ Container: "#popup_tags-page" }) : null; });
                XPortal.Dashboard.Init(content);
                rebiuldTagsPopup();
                onOk(opts);
            });
        },
        PrepareTagsDialogOpts: function (el) {
            let opts = XPortal.Utils.readJsonStr(el.attr("data-dialog")); //get settings for the detail page, if it is a popup the settings have not initialized yet
            if (!opts) return { opts: null, item: null }; // to remove after detail page popup implementation will be ready
            let item = null;
            if (opts) {
                opts.tags = $(el).data("tags");
                const grid = XPortal.Grid.GetGridInfo($("#entity-grid-" + opts.nodeid));
                const tr = $("[data-uniqueid='" + opts.uniqueid || "" + "']").closest("tr");
                if (!grid || !tr) return;
                item = XPortal.Grid.GetGridDataRowItem(grid, tr);
            }
            else { //is popup on a detailpage
                const data = XPortal.Store.GetModelByName(XPortal.TagsEditor.modelName);
                if (!data) return;
                var withEFormat = data.model.Schema.fields.filter(x => x.formatExtended && x.formatExtended.Method)[0];
                opts = withEFormat.formatExtended.Settings;
                opts.fieldname = withEFormat.fieldName;
                opts.width = opts.popupwidthcss;
                opts.ispopup = true;
                if (!opts) return;
                item = data ? data.entity : "";
            }
            return { opts: opts, item: item };
        }
    }
    function initFor($element, modelName, isInlineEditor = false) {
        const inputControl = $element.find(self.controlInputSelector);
        if (!inputControl || !inputControl.length) return;
        let sttgs = self.GetSettings($element, modelName);

        renderTagsEditor(inputControl, sttgs);
        initControls(inputControl, sttgs, isInlineEditor);
        addEvents(inputControl, sttgs, $element);

        initInlineTooltips($element);

        sttgs.data = kendo.observable(sttgs.data);
        const itemsMainCnt = $element.closest(".items-main-container");
        if (itemsMainCnt && itemsMainCnt.length && sttgs.flowtoheader)
            kendo.bind($(itemsMainCnt), sttgs.data);
    };

    function initControls($element, sttgs, isInlineEditor) {
        self.$typeahead = $element.typeahead(Object.assign({ cacheKey: new Date() }, sttgs), {
            name: 'tags',
            source: (q, onRes, onResAsync) => {
                searchTags($element, sttgs, q, sttgs.srcurl).then((d) =>
                    onResAsync(d), (error) => console.log(error), function () { });
            },
            templates: {
                suggestion: (data) => {
                    const res = $("<div/>");
                    $("<div/>").text(data).appendTo(res);
                    return res.html();
                },
                footer: getFooter(),
                empty: getFooter()
            },
            limit: sttgs.limit
        });
    };

    function getFooter() {
        if (self.footerContent) return self.footerContent;
        return self.footerContent = $("#tagsEitorFooterTemplate").html();
    };

    function addEvents(input, sttgs, $element) {

        input.bind('typeahead:select', (ev, suggestion) => {
            addNewTagItem(suggestion, input, sttgs, $element);
            if (!input.hasClass("portal-tags-popup__input"))
                hideInput(input, sttgs);
            rebiuldTagsPopup();
            expandTagsPopup(ev, $element);
            self.$typeahead.typeahead('val', '');
            $(".new-tag-name").addClass("d-none");
            XPortal.DropdownBtns.gridButtons.check($('.detail-top-buttons-wrapper'));
        });

        input.bind('typeahead:render', () => {
            $(".tt-suggestion").last().addClass("mb-5");
        });

        input.bind('typeahead:open', () => {
            $element.find(".new-tag-name").addClass("d-none");
        });

        $(".portal-tags").on("click", (e) => {
            $element.find(".tt-menu").show();
            self.$typeahead.typeahead('val', " ").trigger("focus");
            self.$typeahead.typeahead('val', '');
        });

        $(document).on("click", ".long-tag-dots", (e) => {
            let dotsEl = $(e.target).closest(".long-tag-dots");
            dotsEl.addClass("d-none");
            expandTagsInCnt(e, $element);
        });

        $(document).on("click", ".create-tag", (e) => {
            e.stopImmediatePropagation();
            $element.find(".new-tag-name").addClass("d-none");
            const title = XPortal.Localization.GetCachedString("XTags.DataFormat.MessageTitle", "Warning");
            const allowNewDis = XPortal.Localization.GetCachedString("XTags.DataFormat.AllowNewDisabled", "The possibility to create a new tag is disabled.");
            const createTagError = XPortal.Localization.GetCachedString("XTags.DataFormat.CreateNewTagError", "Create new tags error.");

            const settings = self.items[self.$typeahead.data("editorkey")];

            if (!settings.allownew) return showModalInfo(title, allowNewDis);

            const newTagVal = self.$typeahead.typeahead('val') || input.val();
            if (!newTagVal) {
                self.$typeahead.typeahead('close');
                $element.find(".tt-menu").hide();
                return;
            }
            let loader = XPortal.Loader.show({ 'selector': null, showOverlay: true });
            if (loader)
                loader.removeClass("hidden");
            const res = addNewTagItem(newTagVal, input, settings, $element);
            if (res) {
                saveTags(input, settings, newTagVal);
                rebiuldTagsPopup();
            }
            else
                showModalInfo(title, createTagError);
            XPortal.Loader.hide({ 'selector': null, showOverlay: true });
            self.$typeahead.typeahead('val', '');
            hideInput(input);

            //XPortal.DropdownBtns.gridButtons.checkWithTimeout($('body')) // TODO: Check if it realy need
        });

        $(document).on("expanded", (e) => {
            rebuildTagsGrid();
        });

        $(input).on("focusout", (e) => {
            hideInput(input, sttgs);
        })
    };

    function removeTag(sttgs, input, element, e) {
        let curItems = sttgs.data.items;
        const inx = curItems.indexOf(e.data);
        curItems.splice(inx, 1);
        tagsToSave = curItems.map(x => x.value).length ? curItems.map(x => x.value) : null;
        updateItems(input[0], tagsToSave, sttgs);
        XPortal.Utils.updateKendoObj(curItems, curItems);
        XPortal.DropdownBtns.gridButtons.check($('.detail-top-buttons-wrapper'));
        rebiuldTagsPopup();
    }

    function getTagValueModel(d, element, sttgs) {
        return {
            value: d
        };
    }

    function updateItems(element, tags, sttgs) {
        const curTags = (tags && tags.length) ? tags.join(self.valueSeparator) : null;
        XPortal.Store.FieldEvent(element, curTags, sttgs.modelName, sttgs);
    };

    function renderTagsEditor(editor, sttgs) {
        const tagsMainContainers = sttgs.ispopup ? $(".tags-main-container-popup") : $(".items-main-container");
        tagsMainContainers.removeClass("d-none");
        let editorContainer = editor.closest(self.controlSelector);
        if (sttgs.flowtoheader) {
            if (tagsMainContainers && tagsMainContainers.length && editorContainer && editorContainer.length) {
                $(tagsMainContainers[0]).append(editorContainer);
                editorContainer.removeClass("d-none");
                const editForm = editorContainer.closest(".edit-form");
                if (editForm && editForm.length && !sttgs.ispopup)
                    editForm.find(".save-button.btn.btn-primary").addClass("tags-on-page");
            }
        }
        const tags = sttgs.data.items;
        if (!sttgs.value && !(tags && tags.length) && !editor.hasClass("portal-tags-popup__input"))
            editor.closest(".portal-tags").addClass("d-none");
    };

    var currentRequest = null;

    function searchTags($el, sttgs, q, url) {
        return new Promise((onOk, onError) => {
            const model = XPortal.Store.GetModelByName(sttgs.modelName);
            const curModelFields = getModelFields($el, sttgs.modelName);
            const curTags = sttgs.data.items.map(x => x.value) || [];
            let mainQuery = q == " " ? "" : q;
            let requestModel = JSON.stringify({
                EditorId: sttgs.editorkey,
                GroupCode: sttgs.groupcode,
                UniqueId: sttgs.itemuniqueid || model.entity.UniqueId,
                Fields: curModelFields,
                PageSize: 50,
                NodeId: sttgs.pageid,
                EntityAlias: sttgs.entityalias,
                ParentInfo: null,
                MainQuery: mainQuery,
                Tags: curTags
            });

            currentRequest = jQuery.ajax({
                type: 'POST',
                data: requestModel,
                url: XPortal.Utils.EnsureInProfile(url),
                dataType: "json",
                cache: false,
                contentType: "application/json",
                headers: {
                    "RequestVerificationToken": XPortal.Main.getAntiForgeryToken()
                },
                beforeSend: function () {
                    if (currentRequest != null) {
                        currentRequest.abort();
                    }
                },
                success: function (xdata) {
                    const tags = (xdata.Tags || []).map(x => XPortal.Grid.MapEntity(x, {})).map(x => {
                        return XPortal.Template.GetObjPropValueByName(x, "TagTitle");
                    });
                    let result = _.unique(tags);
                    result = result.filter((el) => !curTags.includes(el));

                    onDataLoaded(result, $el);
                    onOk(result);

                    setNewTagName(result, mainQuery);
                },
                error: function (...args) {
                    onError(args);
                }
            });
        });
    };

    function saveTags($el, sttgs, q) {
        searchTags($el, sttgs, q, sttgs.srcsavetags).then((data) => {
            XPortal.Loader.hide({ 'selector': null, showOverlay: true });
        });
    };

    function getModelFields(el, modelName) {
        var rfields = ((XPortal.Store.GetModelByName(modelName) || {}).entity || {}).Fields;
        if (!rfields || rfields.length < 1) return [];

        rfields = rfields.map(function (fi) {
            var f = { data: "", field: "" };
            f.field = XPortal.Template.GetObjPropValueByName(fi, "Name");
            f.data = XPortal.Template.GetObjPropValueByName(fi, "StringValue");
            if (!(f.data)) f.data = XPortal.Template.GetObjPropValueByName(fi, "data");
            if (f.data && f.data.length > 8192) f.data = f.data.substring(0, 8192);//max data to send to the server
            return f;
        });
        return rfields;
    };

    function onDataLoaded(tags, $el) {
        const tagsAmount = tags.length;
        let button = $el.parent().next("button.create-tag");
        if (!button && !button.length) return;
        if (!tagsAmount)
            button.removeClass("d-none");
        else
            button.addClass("d-none");
    };

    function addNewTagItem(val, $input, sttgs, editor) {
        if (!val && !val.length) return false;
        const curTags = sttgs.data.items;
        if (curTags.find(x => x.value == val)) {
            const title = XPortal.Localization.GetCachedString("XTags.DataFormat.MessageTitle", "Warning");
            const info = XPortal.Localization.GetCachedString("XTags.DataFormat.MessageInfo", "Tag " + val + " is already existed.")
            showModalInfo(title, info);
            return false;
        }
        curTags.push(getTagValueModel(val, $input, sttgs));
        updateItems($input[0], curTags.map(x => x.value), sttgs);

        const addTagBtn = editor.find(".add-tag");
        if (addTagBtn && addTagBtn.length) {
            addTagBtn.removeClass("add-first-tag");
            addTagBtn.find("span").text("");
        }
        return true;
    };

    function hideInput(el, sttgs) {
        if (el.hasClass("portal-tags-popup__input")) return;
        el.addClass("d-none");
        $(".add-tag").removeClass("d-none");
        $(".add-tags").removeClass("d-none");
    };

    function setNewTagName(result, q) {
        XPortal.Utils.waitFor(function () {
            let newTagNameEl = $(".new-tag-name");
            if (!newTagNameEl || !newTagNameEl.length) return false;
            if (!q) {
                $(".new-tag-name").addClass("d-none");
                return true;
            }
            newTagNameEl.removeClass("d-none");
            const isUnique = (result.indexOf(q) == -1);
            if (isUnique) {
                newTagNameEl.text(q);
                addDotsToLongText(newTagNameEl);
            }
            else
                newTagNameEl.css("background", "unset");
            return true;
        }, XPortal.Utils.waitFor, 50);

    };

    function addDotsToLongText(newTagNameEl) {
        const tagElNewSize = $(".create-tag-cnt").width() - $(".create-tag").width();
        if (newTagNameEl.outerWidth() >= tagElNewSize / 1.1) {
            newTagNameEl.width(tagElNewSize * 1.1);
            newTagNameEl.addClass("hide-long-text ");
        }
    };

    function updateItem(sttgs, curTagsArray) {
        const pageId = sttgs.pageid;
        let grid = $("#entity-grid-" + pageId);
        if (grid && grid.length) {
            const uniqueId = sttgs.itemuniqueid;
            let kendoGrid = grid.data("kendoGrid");
            let items = kendoGrid.dataSource.view();
            let oldItemData = {};
            $(items).each(function () {
                if (this.uniqueid == uniqueId)
                    oldItemData = this;
            });
            let newItemData = oldItemData;
            newItemData.tags = curTagsArray.join(self.valueSeparator);
            XPortal.Utils.updateKendoObj(oldItemData, newItemData);
        }
    };

    function expandTagsPopup(e, $element) {
        const dots = $element.find(".long-tag-dots");
        if (dots && dots.length && !dots.hasClass("d-none"))
            dots.trigger("click");
    };

    function showModalInfo(title, message) {
        let modal = $("#modalBox");
        if (!modal || !modal.length) return;
        let button = modal.find(".alert-block");
        button.removeClass("d-none");
        modal.find(".m-info").remove();
        modal.find(".m-text").remove();
        button.find("button").on("click", function () { modal.modal('hide'); })
        modal.find(".modal-header .modal-header-cnt").append(`<h4 class='m-info'>${title}</h4>`);
        modal.find(".modal-body").append(`<h6 class='m-text'>${message}</h6>`);
        modal.modal('show');
    };

    function addDotsButtonGrid(containers, isListView) {
        containers.each(function () {
            let container = $(this);
            if (!container && !container.length)
                return;
            let existedDots = container.find(".long-tag-dots");
            if (existedDots && existedDots.length)
                existedDots.remove();
            let cntChildrenWidth = 0;
            let containerWidth = 0;
            if (isListView) {
                let cntParent = container.closest(".entity-fld-val");
                containerWidth = cntParent.width();
            }
            else
                containerWidth = container.width();

            let children = container.children(".tag-item");
            let dotsAdded = false;
            for (let i = 0; i < children.length; i++) {
                let $tag = $(children[i]);
                let dotsBtnWidth = $(container.children(".edit-tags")).outerWidth(true); //dots btn has the same width as "+" button
                $tag.removeClass("d-none");
                cntChildrenWidth += $tag.outerWidth(true);
                const tagsWidth = (i == children.length - 1) ? cntChildrenWidth : cntChildrenWidth + dotsBtnWidth;
                if (dotsAdded) {
                    $tag.addClass("d-none");
                }
                else if ((containerWidth - dotsBtnWidth) <= tagsWidth) {
                    let dots = $($("#tagsDotsBtn").html());
                    if ($tag.hasClass("expanded")) continue;
                    $(dots).insertBefore(children[i]);
                    $tag.addClass("d-none");
                    dotsAdded = true;
                }
            }
        });
        $(document).on("click", ".long-tag-dots", (e) => {
            expandTagsInCnt(e);
        });
    };

    function expandTagsInCnt(e, $element) {
        let dotsEl = $(e.target).closest(".long-tag-dots");
        dotsEl.addClass("d-none");
        let nextEls = dotsEl.nextAll(".tag-item");
        if (nextEls.length)
            nextEls.each(function () {
                $(this).removeClass("d-none");
                nextEls.addClass("expanded");
            });
        if (!$element) return;
        const tagsPopup = $element.find(".current-tags-popup");
        (tagsPopup && tagsPopup.length) ? tagsPopup.addClass("tags-exp") : "";
    }

    function grid_columnResize(e) {
        rebuildTagsGrid();
    };

    function rebuildTagsGrid() {
        const gridContainers = $(".entity-grid .tags-format-container");
        const listViewCnts = $(".entity-list .tags-format-container");
        if (listViewCnts && listViewCnts.length)
            addDotsButtonGrid(listViewCnts, true);
        if (gridContainers && gridContainers.length)
            addDotsButtonGrid(gridContainers, false);
    };

    function relocateInputPopup() {
        const inputCnt = $(".tags-input-container-popup");
        let last = $(".current-tags-popup");
        inputCnt.insertAfter(last);
    };

    function saveBtnToFooterPopup(ispopup) {
        const saveBtn = $(".tags-pupup-save-btn");
        let footer = $(".modal-content.custom-popup-width .modal-footer");
        if (saveBtn && saveBtn.length && footer && footer.length)
            ispopup ? saveBtn.insertAfter(".edit-btns-wrapper-inpopup") : saveBtn.insertAfter(".edit-btns-wrapper");
    };

    function rebiuldTagsPopup() {
        let cntChildrenWidth = 0;
        XPortal.Utils.waitFor(function () {
            let container = $(".current-tags-popup");
            const containerExpanded = container.hasClass('tags-exp');
            const containerWidth = container.width();
            let children = container.children();
            let width = $(children[0]).width();
            if (width < 0) return false;
            for (let i = 0; i < children.length; i++) {
                cntChildrenWidth += $(children[i]).outerWidth() * 1.2;
            }
            let rowsAmount = cntChildrenWidth / containerWidth;
            if (rowsAmount > 2 && !containerExpanded) {
                const grid = Array.from(container.children());
                let baseOffset = grid[0].offsetTop;
                let breakIndex = grid.findIndex(item => item.offsetTop > baseOffset);
                baseOffset = grid[breakIndex].offsetTop;
                breakIndex = grid.findIndex(item => item.offsetTop > baseOffset);
                let dots = $($("#tagsDotsBtn").html());
                let dotsToRemove = container.find(".long-tag-dots");
                if (dotsToRemove && dotsToRemove.length) {
                    dotsToRemove.remove();
                }

                dots.insertBefore(children[breakIndex]);

                if (dots[0].offsetTop > baseOffset) {
                    container.find(".long-tag-dots").remove();
                    dots.insertBefore(children[breakIndex - 1]);
                }
            }
            return true;
        }, XPortal.Utils.waitFor, 100);
    };

    function initInlineTooltips($element) {
        $element.kendoTooltip({
            show: function (e) {
                this.popup.element.addClass('tags-tooltip');
            },
            filter: '.tag-item',
            position: 'top',
            width: 'auto',
            content: function (e) {
                return $(e.target).find('.tag-text').html();
            }
        });
    };

    return self;
})();

